<template>
  <content-dialog
    :visible.sync="modalVisible"
    persistent
    scrollable
    max-width="600"
  >
    <!--<editor-fold desc="Dialog title">-->
    <template slot="dialogTitle">
      Select type of document you want generated
    </template>
    <!--</editor-fold>-->

    <v-card-text class="pa-2">
      <v-list two-line>
        <v-list-item
          class="list--bordered"
          @click="$emit('document:preview', documentTemplate.TYPE_OFFER, null, null, annexShowEquipmentPrices, language)"
        >
          <v-list-item-content>
            <v-list-item-title>
              Annex1
            </v-list-item-title>
            <v-list-item-subtitle>
              Generate offer from template for this yacht
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action class="flex-row align-center">
            <v-switch
              v-model="annexShowEquipmentPrices"
              label="Show equipment prices"
              dense
              @click.stop
            />
          </v-list-item-action>
        </v-list-item>
        <v-list-item
          v-if="showGuaranteed"
          class="list--bordered"
          @click="$emit('document:preview', documentTemplate.TYPE_INVESTMENT_PROGRAM, null, null, false, language)"
        >
          <v-list-item-content>
            <v-list-item-title>
              Guaranteed Investment Program
            </v-list-item-title>
            <v-list-item-subtitle>
              Offer - only applies to guaranteed program
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-for="template in documentTemplates"
          :key="template.id"
          class="list--bordered"
          @click="template.file ? openFile(template.file.id) : $emit('document:preview', documentTemplate.TYPE_CONTRACT, template.id, null, false, language)"
        >
          <v-list-item-content>
            <v-list-item-title>
              {{ template.title }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ template.description }}
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action v-if="!template.file">
            <v-checkbox
              v-model="selectedDocuments"
              dense
              :value="template.id"
              @click.stop
            />
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-card-text>

    <template slot="dialogActions">
      <v-btn-toggle
        v-model="language"
        mandatory
        dense
        color="primary"
        class="ml-2"
      >
        <v-btn
          v-for="lang in languages"
          :key="lang.value"
          :value="lang.value"
          small
        >
          {{ lang.value.toUpperCase() }}
        </v-btn>
      </v-btn-toggle>
      <v-spacer />
      <v-btn
        text
        color="grey"
        @click="modalVisible = false"
      >
        Cancel
      </v-btn>
      <v-btn
        :disabled="selectedDocuments.length === 0"
        color="primary"
        @click="$emit('document:preview', documentTemplate.TYPE_CONTRACT, selectedDocuments, null, false, language)"
      >
        Generate selected
      </v-btn>
    </template>
  </content-dialog>
</template>

<script>
import DocumentTemplate from '@/models/DocumentTemplate'
import ContentDialog from '@/components/helpers/Dialog'
import File from '@/models/File'

export default {
    name: 'DocumentTypeSelectorDialog',
    components: {
      ContentDialog
    },
    props: {
      visible: Boolean,
      documentTemplates: {
        type: Array,
        default: () => []
      },
      showGuaranteed: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        annexShowEquipmentPrices: false,
        selectedDocuments: [],
        language: 'en',
        languages: [
          { text: 'English', value: 'en' },
          { text: 'French', value: 'fr' }
        ]
      }
    },
    computed: {
      modalVisible: {
        get: function () {
          return this.visible
        },
        set: function (value) {
          this.$emit('update:visible', value)
        }
      },
      documentTemplate() {
        return DocumentTemplate
      }
    },
    methods: {
      openFile(fileId) {
        File.api.openDocument(fileId)
      }
    }
  }
</script>

<style scoped>
</style>
